// @NgModule decorator with its metadata
var NavbarModule = /** @class */ (function () {
    function NavbarModule() {
    }
    return NavbarModule;
}());
export { NavbarModule };
